import { Icon, Spacer, Text } from "@zapier/design-system";

import styles from "./SummaryActors.module.css";
import { useAtomValue } from "jotai";
import { actorsAtomFamily } from "@zapier/canvas-state";

type Props = {
  onlyForSelectedNodes?: boolean;
  darkMode?: boolean;
};

export function SummaryActors({
  onlyForSelectedNodes = false,
  darkMode = false,
}: Props) {
  const actors = useAtomValue(actorsAtomFamily(onlyForSelectedNodes));

  return (
    <>
      <Text type="SmallPrint3" color={darkMode ? "PrimeWhite" : "GrayWarm10"}>
        Actors
      </Text>
      <Spacer height={5} />
      {actors.length === 0 && (
        <Text type="SmallPrint1" color="GrayWarm6">
          <span>People or groups involved will be displayed here.</span>
        </Text>
      )}
      <ul className={styles.actorList}>
        {actors.map((actor) => (
          <li className={styles.actorItem} key={actor.label}>
            <Icon
              name="personCircleFill"
              color={actor.color || "GrayWarm3"}
              size={24}
            />
            <Text
              type="SmallPrint2"
              color={darkMode ? "PrimeWhite" : "GrayWarm10"}
            >
              {actor.label}
            </Text>
          </li>
        ))}
      </ul>
    </>
  );
}
